<template>
  <div>
    <base-breadcrumb-bar :pageTitle="`Manage ${tabs[tab].text}`">
      <!-- <area-filter
          v-for="(e, i) in tabs"
          :keys="i"
          :queryLimit="e.queryLimit"
          :type="e.type"
          :areaFilters.sync="e.search"
          v-if="i == tab"
        /> -->
      <!-- put display none to just hide but to retain data -->

      <v-row> </v-row>
      <!-- </template> -->
    </base-breadcrumb-bar>
    <div></div>

    <!-- <v-tabs-items v-model="tab">
      <v-tab-item v-for="(e, i) in tabs" :keys="i"> -->
    <area-section />
    <!-- </v-tab-item>
    </v-tabs-items> -->
  </div>
</template>

<script>
import AreaSection from "@/components/Base/Areas/AreaSection";
import AreaFilter from "@/components/Base/Areas/AreaFilter";

export default {
  name: "ViewAdmins",
  components: {
    AreaSection,
    // AreaFilter,
  },
  data() {
    return {
      tabs: [
        {
          text: "Zones",
          icon: "mdi-map-marker-radius",
          queryLimit: { description: "Zone" },
          type: "zone",
          search: {},
        },
        {
          text: "Areas",
          icon: "mdi-map-marker-radius",
          queryLimit: { description: "Area" },
          type: "area",
          search: {},
        },
        {
          text: "Suburbs",
          icon: "mdi-map-marker-radius",
          queryLimit: { description: { $in: ["Suburb", "Extension"] } },
          type: "suburb",
          search: {},
        },
        {
          text: "Cities",
          icon: "mdi-map-marker-radius",
          queryLimit: { description: "City" },
          type: "city",
          search: {},
        },
        {
          text: "Regions",
          icon: "mdi-map-marker-radius",
          queryLimit: { description: "Province" },
          type: "region",
          search: {},
        },
      ],
      tab: 1,
      currentAreas: [],
    };
  },
  apollo: {},
  computed: {},
  methods: {},
  watch: {},
};
</script>
